











/* Created- 05 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import EventBus from "../../../Plugins/eventbus";
@Component(
	{
		name: "ParticaLoader"
	})
export default class ParticaLoader extends Vue {
	private counter: number = 0;
	private loadingdialog: boolean = false;
	private created() {
		EventBus.$on("loading-start", async (data: any) =>
			this.handleEvent(true)
		);
		EventBus.$on("loading-end", async (data: any) =>
			this.handleEvent(false)
		);
	}
	private async handleEvent(starting: boolean) {

		if (starting) {
			this.counter++;
		} else {
			if (this.counter > 0) {
				this.counter--;
			}
		}
		if (this.counter > 0) {
			this.loadingdialog = true;
		} else {
			this.loadingdialog = false;
		}

	}

}
